import Handlebars from "handlebars";

Handlebars.registerHelper("variantUrl", function (assetId, deviceType, options) {
  if (options.url) {
    return options.url;
  }

  var params = Object.keys(options)
    .reduce(function (a, k) {
      if (options[k] !== null && options[k] !== undefined) {
        a.push(k + "=" + encodeURIComponent(options[k]));
      }
      return a;
    }, [])
    .join("&");
  return new Handlebars.SafeString("/admin/assets/" + assetId + "/cropped?device_type=" + deviceType + "&" + params);
});
